import store from '@/store';

export const authGuard = (to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
      return;
    }

    if (to.matched.some(record => record.meta.requiresAdmin)) {
      const isAdmin = store.getters['auth/isAdmin'];
      if (!isAdmin) {
        next({ path: '/portfolios' });
        return;
      }
    }

    next();
  } else {
    next();
  }
};
